import { initElmApp } from 'elm/utilities'
import * as Events from 'elm/src/Events.elm'

export function init (): null {
  const app = initElmApp(Events)

  const bodyElement = document.querySelector('body')

  const debouncedScrollHandler = _.debounce(() => {
    const scrollPosition = bodyElement.scrollTop + bodyElement.clientHeight
    const scrollHeight = bodyElement.scrollHeight

    if (scrollPosition >= scrollHeight) {
      app.ports.loadMore.send(null)
    }
  }, 300)

  bodyElement.addEventListener('scroll', debouncedScrollHandler)
}
